module.exports = __webpack_public_path__ + "img/_notifications_profile.c7d5231d.svg";